// extracted by mini-css-extract-plugin
export var baseButton = "_pi-0";
export var controlsArrowKeys = "_pi-1";
export var controlsResetButton = "_pi-2";
export var lightGameButton = "_pi-4 _pi-0";
export var playAgainButton = "_pi-5 _pi-0";
export var startGameButton = "_pi-3 _pi-0";